import type { ArrowDownIconProps } from './types';

export const ArrowDown = ({ className }: ArrowDownIconProps) => (
    <svg width={8} height={4} viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M0 0h8L4 4 0 0z" />
    </svg>
);

export default ArrowDown;
